module.exports = require('./build/Art.StandardLib/Core');
